import { useState } from 'react'

import { useFeatureFlag } from 'features/user/hooks/useFeatureFlag'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_AB_TEST } from './api/query'
import { Data, Variables } from './api/types'

import type { AbTestSlice, UseGet, UseGetProps } from './types'

export const useGetAbTest = ({ id }: UseGetProps): UseGet => {
  const [abTest, setAbTest] = useState<AbTestSlice | undefined>()

  const { isFeatureEnabled: withYp2395 } = useFeatureFlag('yp2395AbTestsDivideTraffic')

  const { isLoading: loading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const { node: abTest } = data

      if (abTest) {
        setAbTest(fromDTO({ withYp2395, ...abTest }))
      }
    },
    query: GET_AB_TEST({ withYp2395 }),
    variables: { id },
  })

  return { abTest, loading }
}
